module.exports = __webpack_public_path__ + "img/tabbar_lightskin_5.de915eaf.png";